var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg015Aerosol = function Svg015Aerosol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M346 0h30v30h-30zM346 60h30v30h-30zM406 60h30v30h-30zM406 0h30v30h-30zM406 120h30v30h-30zM76 180h270v60H76zM316 30h-75V0h-60v63.625C190.683 61.412 200.656 60 211 60h105zM116.532 150h188.936C288.547 114.655 252.726 90 211 90s-77.547 24.655-94.468 60M316 270H106v242h210v-45H196V315h120z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226 345h90v92h-90z"
  })));
};
export default Svg015Aerosol;